import React, { useState } from "react";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Box, ButtonBase, TextField } from "@mui/material";
import { withStyles } from "tss-react/mui";

import { SelectTemplateDialogListItemFragment } from "@/gql/graphql";
import useDialogState from "@/hooks/useDialogState";
import useGlobalSnackbar from "@/hooks/useGlobalSnackbar";

import SelectTemplateDialog from "./SelectTemplateDialog";

interface Props {
  onSelect(templateId: string): Promise<void>;
}

const StyledButtonBase = withStyles(ButtonBase, {
  root: {
    "& .MuiTouchRipple-root": {
      marginBottom: 23, // adjust so that ripple doesnt include helper text space
    },
  },
});

const StyledTextField = withStyles(TextField, {
  root: {
    width: "100%",
    "& .MuiInputBase-root": {
      fontSize: "1.2rem",
      color: "#C0C5CD",
    },
  },
});

const NoInteraction = withStyles(Box, {
  root: {
    pointerEvents: "none",
  },
});

const SelectTemplateButton: React.FC<Props> = ({ onSelect }) => {
  const snackbar = useGlobalSnackbar();
  const dialog = useDialogState();
  const [label, setLabel] = useState<string>();

  function handleSelectTemplate(
    template: SelectTemplateDialogListItemFragment
  ) {
    setLabel(template.name);
    onSelect(template.id).then(() => {
      snackbar.open("Template applied successfully");
    });
  }

  return (
    <>
      <StyledButtonBase onClick={dialog.show}>
        <NoInteraction>
          <StyledTextField
            label={label ?? "Select a template to use"}
            helperText=" "
            aria-readonly
            InputLabelProps={{
              shrink: false,
            }}
            InputProps={{
              readOnly: true,
              endAdornment: <ArrowDropDownIcon />,
            }}
          />
        </NoInteraction>
      </StyledButtonBase>
      <SelectTemplateDialog
        open={dialog.shown}
        onClose={dialog.hide}
        onSelectTemplate={handleSelectTemplate}
      />
    </>
  );
};

export default SelectTemplateButton;
